import { render, staticRenderFns } from "./LastInterventions.vue?vue&type=template&id=3bcb8aa6&"
import script from "./LastInterventions.vue?vue&type=script&lang=js&"
export * from "./LastInterventions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports